import { render, staticRenderFns } from "./SalesBasket.vue?vue&type=template&id=a68e43c6"
import script from "./SalesBasket.vue?vue&type=script&lang=js"
export * from "./SalesBasket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports